import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Button,
  Grid,
} from "@material-ui/core";
import SearchBar from "material-ui-search-bar";
import ReactReadMoreReadLess from "react-read-more-read-less";
import * as React from "react";
import { useState } from "react";

// For processing data
import { buildQueryParams, transformDataCustomSelect } from "utils/common.js";
import DocumentsService from "services/DocumentsService.js";
import { MAX_CATEGORY_LIMIT } from "constants/common.js";

import { useEffect } from "react";
import { useStyles } from "./style.js";
import { debounce } from "lodash";

const documentsServiceObj = new DocumentsService();

// This is the header for the table
const columns = [
  { id: "title", label: "Title" },
  { id: "description", label: "Description", minWidth: 10 },
  { id: "action", label: "Actions" },
];

//!----------------------------
export default function DocumentsWidget() {
  const classes = useStyles();
  const [assetsData, setAssetsData] = useState([]);
  const [documentsCategory, setDocumentsCategory] = useState([]);
  const [documentType] = useState(0);
  const [totalAssetsCount, setTotalAssetsCount] = useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  //* For Filtering
  const [searched, setSearched] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handling the click of "view" button //* Done
  const handleClick = (url) => {
    window.open(url, "_blank").focus();
  };

  //! -----------------------------------------------------
  //! Needs to be explained
  useEffect(() => {
    getAssetsData();
    // eslint-disable-next-line
  }, [documentType, searched, rowsPerPage, page]);

  //! --------------------------------------------------------
  //! Need to be explained
  useEffect(() => {
    let urlParams = {
      is_deleted: false,
      limit: MAX_CATEGORY_LIMIT,
    };
    let documentsCategory = [{ label: "All Documents", value: 0 }];
    documentsServiceObj
      .getDocumentsCategoryList(buildQueryParams(urlParams))
      .then((response) => {
        if (response) {
          setDocumentsCategory([
            ...documentsCategory,
            ...transformDataCustomSelect(response.results),
          ]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line
  }, []);
  //! ----------------------------------------------------------
  //! Need to be explained
  const getAssetsData = () => {
    let urlParams = {};
    urlParams["ordering"] = "-id"; //default sorting - is used for decending
    urlParams["limit"] = rowsPerPage;
    urlParams["offset"] = rowsPerPage * (page + 1 - 1);
    urlParams["is_deleted"] = false;
    urlParams["name"] = searched;
    if (documentType !== 0) {
      urlParams["documents_category"] = documentsCategory.filter(
        (el) => el.value === documentType
      )[0].label;
    }
    documentsServiceObj
      .getDocumentsList(buildQueryParams(urlParams))
      .then((response) => {
        if (response) {
          setAssetsData(response.results);
          setTotalAssetsCount(response.count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // for typing in the searchbar
  const requestSearch = (searchedVal) => {
    debounceSearchDocData(searchedVal)
  };

  const debounceSearchDocData = debounce(searchedVal=>{
    setSearched(searchedVal)
  },1000);

  // for a blank searchbar
  const cancelSearch = () => {
    setSearched("");
  };
  //* end of filtering methods
  return (
    <Paper elevation={0} style={{ minWidth: "100%" }}>
      <Paper elevation={5}>
        <Paper elevation={0} sx={{ pl: 5, pt: 5, pr: 5 }}>
          <Grid
            container
            direction="row"
            spacing={2}
            style={{ paddingLeft: 10, paddingBottom: 10 }}
          >
            <Grid item>
              <SearchBar
                placeholder="Search Documents"
                value={searched}
                onChange={(searchVal) => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
              />
            </Grid>
            {/* //TODO tag filtering for the future
            <Grid item>
              <TextField
                label="Filter Tags"
                variant="outlined"
                size="small"
                /*
                          InputProps={{
                              startAdornment: (
                                  <InputAdornment position="start">
                                  <FilterListIcon />
                                  </InputAdornment>
                              )}}
                          
                sx={{ width: "15%" }}
              />
            </Grid>
            <Grid item xs="6" sm="3">
              <Button variant="outlined" color="neutral">
                Filter
              </Button>
              <Button className={classes.masterBtn} type="submit">
                Submit
              </Button>
            </Grid>
                              */}
          </Grid>
          {/* //TODO tag filtering for the future
                    
                    <Grid container direction='row' spacing={1} style={{paddingLeft:20, paddingTop:5,paddingBottom:5}} >
                      <Grid item>
                        <FormLabel component="legend">Filters:</FormLabel>
                      </Grid>
                      <Grid item>    
                        <Chip variant='outlined' label="VSP" size='small' onDelete={handleClick} />
                      </Grid>
                      <Grid item>
                        <Chip variant='outlined' label="This" size='small' onClick={handleClick} />
                      </Grid>
                      <Grid item>  
                        <Chip variant='outlined' label="That" size='small' onClick={handleClick} />
                      </Grid>
                      <Grid item>
                        <Chip variant='outlined' label="Manuals" size='small' onClick={handleClick} />
                      </Grid>
                      <Grid item>
                        <Chip variant='outlined' label="test" size='small' onClick={handleClick} />
                      </Grid>
                    </Grid>
                              */}
        </Paper>
        <Paper sx={{ pl: 3, pr: 3, pb: 3, pt: 2 }} elevation={0}>
          <Paper elevation={0}>
            <TableContainer
              style={{
                minWidth: "100%",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.title}
                        align="left"
                        style={{
                          minWidth: column.minWidth,
                          fontWeight: "bold",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assetsData.map((row) => (
                    <TableRow key={row.name} hover>
                      <TableCell
                        style={{
                          fontWeight: "bold",
                          minWidth: 150,
                          maxWidth: 150,
                        }}
                      >
                        {row.name}
                      </TableCell>
                      <TableCell style={{ minWidth: '100%', maxWidth: '100%' }}>
                        <ReactReadMoreReadLess
                          charLimit={200}
                          readMoreText={"Read more..."}
                          readLessText={"Read less..."}
                          readMoreClassName={classes.readMore}
                          readLessClassName={classes.readMore}
                          className={row.description}
                        >
                          {row.description}
                        </ReactReadMoreReadLess>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          //endIcon={<ForwardIcon />}
                          onClick={() => handleClick(row.link)}
                          style={{
                            textTransform: "none",
                            fontWeight: "500",
                            fontFamily: [
                              "Roboto",
                              "Helvetica",
                              "Arial",
                              "sans-serif",
                            ],
                            backgroundColor: "#bd0912",
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {
              //* This pagination is outside of the table container to make it sticky
            }
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100, 500]}
              component="div"
              count={totalAssetsCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ pr: 20 }}
            />
          </Paper>
        </Paper>
      </Paper>
    </Paper>
  );
}
